import React from 'react'
import { connect } from 'react-redux'
// import moment from 'moment'
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import DRP from './inputs/DashboardRangePicker'

import MenuItem from '@material-ui/core/MenuItem'
import FormSelect from './inputs/FormSelect'

import ResponsiveLine from './graphs/ResponsiveLine'
import ResponsiveBar from './graphs/ResponsiveBar'
import ResponsivePie from './graphs/ResponsivePie'
import Loader from './Loader'
import Select from '@material-ui/core/Select';

import {
  format_number
} from '../helpers'

import {
  get_graphs,
  reset_graphs,
  clear_graph_dates,
  skills_index,
  coupons_select,
  campaign_select,
  set_path
} from '../actions'

const mapStateToProps = state => {
  const { data, from, to, time_start, total_users, total_tests, invites, consumed, total_vouchers, fetching, fetched, timestamp, errors } = state.graph
  return {
    graphs: data,
    from, to, time_start,
    total_users, total_tests, invites, consumed, total_vouchers,
    fetching, fetched,
    timestamp, errors,
    current_user: state.auth.current_user.data,
    coupons: state.coupon.select_items,
    campaigns: state.voucher.campaigns,
    skills: state.skill.items
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getGraphs: (graph_types=[], from=null, to=null, coupon=null, campaign=null) => dispatch( get_graphs(graph_types, from, to, coupon, campaign) ),
    resetGraphs: () => dispatch( reset_graphs() ),
    getSkills: () => dispatch( skills_index() ),
    getCoupons: () => dispatch( coupons_select() ),
    clearDates: () => dispatch( clear_graph_dates() ),
    getCampaigns: () => dispatch( campaign_select() ),
    setPath: path => dispatch( set_path(path))
  }
}

class ConnectedDashboard extends React.PureComponent {
  state = {
    from: null,
    to: null,
    timestamp: null,
    graph_types: [],
    graph_config: [],
    skill: 'all',
    mounted: false,
    coupon: 'all',
    campaign: 'all',
  }

  graph_types = {
    client: [ 'tests_served', 'vouchers_status', 'tests_per_skill', "test_levels" ]
  }

  graph_config = {
    client: [
      {
        id: 'tests_served', type: 'line', md: 8, xs: 12, yaxis: 'Tests Taken', xaxis: "",
        title: 'TESTS SERVED', subtitle: "Number of tests served",
        rotateOnSmall: true, headers: { count: {text: "All Tests"} }
      },
      {
        id: 'vouchers_status', type: 'pie', md: 4, xs: 12, variant: "number_to_percent",
        title: 'VOUCHER USAGE', subtitle: `Vouchers per status [total: @@TAG@@]`, skipBlanks: true, tag: 'total_vouchers'
      },
      {
        id: 'tests_per_skill', type: 'bar', md: 8, xs: 12, yaxis: "Tests Taken", xaxis: "Skill",
        title: 'CREDIT USAGE', subtitle: "Breakdown of usage per skill",
        rotateOnSmall: true, headers: ["label", "count"], match: {count: "All tests"}, color: 'bright', forceFirstColors: ["#9467bd"]
      },
      {
        id: 'test_levels', type: 'pie', md: 4, xs: 12, variant: "percent",
        title: 'RESULTS PER LEVEL', subtitle: "% instances per level",
        hasSelector: true, state: 'skill', all: "All Skills", forceFirstColors: [ "rgba(31, 119, 180, 0.65)",
          // #ff7f0e - 25%
          "rgba(255, 127, 14, 0.65)",
          // #2ca02c  - 25 %
          "rgba(44, 160, 44, 0.65)",
          // #d62728  - 25 %
          "rgba(214, 39, 40, 0.65)",
          // #9467bd  - 25 %
          "rgba(148, 103, 189, 0.65)",
          // #8c564b  - 25 %
          "rgba(140, 86, 75, 0.65)",
          // #e377c2  - 25 %
          "rgba(227, 119, 194, 0.65)",
          // #7f7f7f  - 25 %
          "rgba(127, 127, 127, 0.65)",
          // #bcbd22  - 25 %
          "rgba(188, 189, 34, 0.65)",
          // #17becf  - 25 %
          "rgba(23, 190, 207, 0.65)"
        ]
      },
    ]
  }

  componentWillMount() {
    const { timestamp, getGraphs, resetGraphs, to } = this.props
    const from = null//moment().startOf('year').format()
    resetGraphs()

    if ( this.props.skills.length === 0 ) {
      this.props.getSkills()
    }

    if ( this.props.coupons.length === 0 ) {
      this.props.getCoupons()
    }

    if ( this.props.campaigns.length == 0 ) {
      this.props.getCampaigns()
    }
    const graph_types = this.graph_types['client']
    const graph_config = this.graph_config['client']
    this.props.setPath('dashboard')

    this.setState({from, to, timestamp, graph_types, graph_config})
    getGraphs(graph_types, from, to)

  }

  componentDidUpdate(prevProps, prevState) {
    // if (!this.state.mounted && this.props.timestamp !== prevProps.timestamp ) {
    if (!this.state.mounted && prevProps.timestamp === null && this.props.timestamp !== prevProps.timestamp && this.props.time_start !== null) {
      this.props.getGraphs(this.state.graph_types, this.props.time_start, this.props.to, this.state.coupon, this.state.campaign )
      // return this.setState({mounted: true})
    } else if (!this.state.mounted && this.props.timestamp !== prevProps.timestamp && this.props.time_start !== null) {
      return this.setState({mounted: true})
    }
    if (prevProps.timestamp !== this.props.timestamp) {
      const { from, to, timestamp } = this.props
      this.setState({ from, to, timestamp })
    }
  }

  handleDates = (dates) => {
    // console.log(dates)
    const {from, to} = dates
    this.props.getGraphs(this.state.graph_types, from, to, this.state.coupon, this.state.campaign)
  }

  handleSkill = e => {
    const { target } = e
    this.setState({skill: target.value})
  }

  handleView(e, option="coupon") {
    const { value } = e.target
    const {from, to, getGraphs} = this.props
    let coupon, campaign
    if ( option === "coupon" ) {
      coupon = value
      campaign = this.state.campaign
    } else if ( option === 'campaign' ) {
      campaign = value
      coupon = this.state.coupon
    }
    getGraphs(this.state.graph_types, from, to, coupon, campaign)
    this.setState({campaign: campaign, coupon: coupon})
  }

  render() {
    const { graphs, total_users, total_tests, invites, consumed, total_vouchers, current_user, time_start } = this.props
    const { mounted, graph_config } = this.state
    const { from, to, } = this.props
    if ( !mounted  ) {
      return <Loader />
    }

    const display_vouchers = (invites, consumed, total_vouchers) => {
      const tv = total_vouchers || 0
      const inv = invites || 0
      const avail = tv - inv
      // return `${tv} / ${inv} / ${consumed || 0} / ${avail}`
      // return `${inv} / ${consumed || 0}`
      return `${avail} / ${tv}`
    }

    return(
      <div className="instalevel-dashboard">
        <Grid container spacing={24} justify="space-between">
          <Grid item xs={12} md={12} use="header">
            <Paper className="dashboard-paper" square={true}>
              <Grid container spacing={24} justify="space-between" alignItems="center">
                <Grid item className="dashboard-text dashboard-title" xs={12} md={6}>
                  Dashboard {current_user.business_name ? `[${current_user.business_name}]` : ''}
                </Grid>
                <Grid item className="dashboard-text dashboard-picker" xs={12} md={6} container justify="flex-end">

                  <Grid item className="mr-24 dashboard-variant-picker" >
                    <FormSelect
                      value={this.state.campaign}
                      onChange={(e) => this.handleView(e, 'campaign')}
                    >
                      <MenuItem className="dashboard-menu-item" value='all'>All Campaigns</MenuItem>
                      <MenuItem className="dashboard-menu-item dashboard-disabled-item" disabled value='chooser'>Choose Campaign:</MenuItem>
                      {
                        this.props.campaigns.map( campaign => {
                          return <MenuItem className="dashboard-menu-item" key={campaign} value={campaign}>{campaign}</MenuItem>
                        })
                      }
                    </FormSelect>
                  </Grid>

                  <Grid item className="mr-24 dashboard-variant-picker" >
                    <FormSelect
                      value={this.state.coupon}
                      onChange={(e) => this.handleView(e, 'coupon')}
                    >
                      <MenuItem className="dashboard-menu-item" value='all'>All Coupons</MenuItem>
                      <MenuItem className="dashboard-menu-item dashboard-disabled-item" disabled value='chooser'>Choose Coupon:</MenuItem>
                      {
                        this.props.coupons.map( coupon => {
                          return <MenuItem className="dashboard-menu-item" key={coupon.id} value={coupon.name}>{coupon.name}</MenuItem>
                        })
                      }
                    </FormSelect>
                  </Grid>

                  <Grid item>
                    <DRP
                      startDate={from}
                      endDate={to}
                      timeStart={time_start}
                      handleChange={ dates => {
                        this.handleDates(dates)
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={4} md={4}>
            <Paper className="dashboard-paper" square={true}>
              <div className="dashboard-graph-title dashboard-totals-title">NEW USERS</div>
              <div className="dashboard-graph-data dashboard-totals-data">{format_number(total_users, false)}</div>
            </Paper>
          </Grid>
          <Grid item xs={4} md={4}>
            <Paper className="dashboard-paper" square={true}>
              <div className="dashboard-graph-title dashboard-totals-title">TESTS TAKEN</div>
              <div className="dashboard-graph-data dashboard-totals-data">{format_number(total_tests, false)}</div>
            </Paper>
          </Grid>
          <Grid item xs={4} md={4}>
            <Paper className="dashboard-paper" square={true}>
              {
                // <div className="dashboard-graph-title dashboard-totals-title">VOUCHERS (total/invites/used/available)</div>
              }
              <div className="dashboard-graph-title dashboard-totals-title">VOUCHERS (available/total)</div>
              <div className="dashboard-graph-data dashboard-totals-data">{display_vouchers(invites, consumed, total_vouchers)}</div>
            </Paper>
          </Grid>

          {
            graph_config.map( (gc, i) => {
              const {
                id, xs, md, title, subtitle, headers, xaxis, yaxis,
                type, variant, match, color, rotateOnSmall, valueTag, decimals,
                hasSelector, state, all, skipBlanks, tag, forceFirstColors
              } = gc
              const state_state = this.state[state]
              const graphData = (graphs[id] && graphs[id][state_state] ? graphs[id][state_state] : graphs[id])
              const comp = (type === 'pie') ? (
                <ResponsivePie
                  graphData={graphData}
                  skipBlanks={skipBlanks}
                  color={color}
                  variant={variant}
                  decimals={decimals}
                  valueTag={valueTag}
                  forceFirstColors={forceFirstColors}
                  id={id}
                />
              ) : ( type === 'bar') ? (
                <ResponsiveBar
                  headers={headers}
                  graphData={graphData}
                  xaxis={xaxis}
                  yaxis={yaxis}
                  match={match}
                  color={color}
                  rotateOnSmall={rotateOnSmall}
                  forceFirstColors={forceFirstColors}
                />
              ) : (
                <ResponsiveLine
                  headers={headers}
                  graphData={graphData}
                  rotateOnSmall={rotateOnSmall}
                  xaxis={xaxis}
                  yaxis={yaxis}
                />
              )

              return (
                <Grid key={`graph_${i}`} item xs={xs} md={md}>
                  <Paper className="dashboard-paper" square={true} >
                    <div className="dashboard-graph-title">{title}</div>
                    <div className="dashboard-graph-subtitle">{tag ? subtitle.replace('@@TAG@@', this.props[tag]) : subtitle}</div>
                    {
                      hasSelector && (
                        <React.Fragment>
                          <Select
                            native
                            value={this.state.skill}
                            onChange={this.handleSkill.bind(this)}
                            style={{
                              // minWidth: 110
                              width: '100%'
                            }}
                            className="formControlSelect"
                          >
                            {
                              Object.keys(graphs[id]).map( item => {
                                return(
                                  <option key={item} value={item}>{item === "all" ? all : item}</option>
                                )
                              })
                            }
                          </Select>
                        </React.Fragment>
                      )
                    }
                    <div style={{height: hasSelector ? 368 : 400}} className={`instalevel-${type}-chart`} id={id}>
                      { comp }
                    </div>
                  </Paper>
                </Grid>
              )
            })
          }

        </Grid>
      </div>
    )
  }
}

const Dashboard = connect(mapStateToProps, mapDispatchToProps)(ConnectedDashboard)
export default Dashboard



// WEBPACK FOOTER //
// ./src/js/components/Dashboard.js